import { createSlice } from '@reduxjs/toolkit';

import { uploadSampleQcMetadata } from '../../apis';

export const ChinaSampleQcSlice = createSlice({

    name: 'chinaQcSample',
    initialState: {
        isLoading: false,
        error: '',
        uploadSampleQcMetadataSuccess: false,
    },

    reducers: {
        clearUploadSampleQcMetadataSuccess: (state, action) => {
            return {
                ...state,
                uploadSampleQcMetadataSuccess: action.payload
            }
        },
        clearError: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        },
    },

    extraReducers: (builder) => {
        builder.addCase(uploadSampleQcMetadata.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(uploadSampleQcMetadata.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.uploadSampleQcMetadataSuccess = true;
        })
        builder.addCase(uploadSampleQcMetadata.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
    }
})

export const { clearUploadSampleQcMetadataSuccess, clearError } = ChinaSampleQcSlice.actions
export default ChinaSampleQcSlice.reducer